module.exports = __webpack_public_path__ + "static/media/edit-calendar.4fd8e42e.svg";